export const MAX_ITEMS = 'X-HSP-MAX-ITEMS';
export const NO_RETRY_HEADER = 'X-NO-RETRY';
export const SET_AUTHORIZATION = 'X-HSP-Set-Authorization';
export const TOKEN_EXPIRED = 'X-HSP-Token-Expired';
